import { render, staticRenderFns } from "./ShowPercepcionMaternidad.vue?vue&type=template&id=0ebadaba&scoped=true&"
import script from "./ShowPercepcionMaternidad.vue?vue&type=script&lang=js&"
export * from "./ShowPercepcionMaternidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebadaba",
  null
  
)

export default component.exports